import { render, staticRenderFns } from "./orderGoodsLabels.vue?vue&type=template&id=30586024&scoped=true&"
import script from "./orderGoodsLabels.vue?vue&type=script&lang=js&"
export * from "./orderGoodsLabels.vue?vue&type=script&lang=js&"
import style0 from "./orderGoodsLabels.vue?vue&type=style&index=0&id=30586024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30586024",
  null
  
)

component.options.__file = "orderGoodsLabels.vue"
export default component.exports